import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_PAYMENT_RESET = 'DELETE_PAYMENT_RESET';
export const DELETE_PAYMENT_LOADING = 'DELETE_PAYMENT_LOADING';
export const DELETE_PAYMENT_SUCCESS = 'DELETE_PAYMENT_SUCCESS';
export const DELETE_PAYMENT_REJECT = 'DELETE_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const deletePaymentReset = () => ({ type: DELETE_PAYMENT_RESET });
export const deletePaymentLoading = () => ({ type: DELETE_PAYMENT_LOADING });
export const deletePaymentSuccess = (payload) => ({ type: DELETE_PAYMENT_SUCCESS, payload });
export const deletePaymentReject = (payload) => ({ type: DELETE_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deletePaymentRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/TypePayments/${data.id}`, options);
};